import moment from 'moment';
import React, { Component } from 'react';
import { Toast } from 'antd-mobile';
import { Button, Dialog, Space } from 'antd-mobile-v5';
import { changeStatus } from "apis/material";
import './index.less';

export default class Queue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waitNo: 0, // 排队区等待位数
            queuecode: 0, // 排队区排队编号
            queueName: '', // 排队区排队名称
            noticePK: '', // 排队区二维码的pk
            timeState: '刚刚更新',
            queueStatus: "",
            vprocessstatus: 10,
            pk_org: ""
        }
    }

    timer = null;

    componentDidMount() {
        const { materialData } = this.props;
        this.setState({
            waitNo: materialData?.queueMonitor?.waitNo,
            queuecode: materialData?.queueMonitor?.queuecode,
            queueName: materialData?.queueMonitor?.queuearea_name,
            noticePK: materialData?.pk_delivery,
            queueStatus: materialData?.queueMonitor?.queueStatus?.name,
            vprocessstatus: materialData?.vprocessstatus,
            pk_org: materialData?.stockorg?.pk_org
        })

        this.timer = setTimeout(() => {
            let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            this.setState({
                timeState: now
            })
        }, 5000);
    }

    // 刷新排队区的信息
    refresh = () => {
        const { getQueueRefresh, materialData } = this.props;
        getQueueRefresh(true);

        clearTimeout(this.timer);
        this.setState({ timeState: '刚刚更新' });
        this.timer = setTimeout(() => {
            let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            this.setState({
                timeState: now
            })
        }, 5000);
    }

    render() {
        const { timeState, noticePK, pk_org } = this.state;
        const { getDetailInfo, materialData } = this.props;
        return (
            <div>
                <div className="body-queue">
                    <div className="body-queue-head">
                        <div>排队</div>
                        <div>
                            <div style={{ fontSize: "0.33rem", fontWeight: "600", color: "red" }}>{timeState}</div>
                            <div className="head-shuaxin" onClick={() => { this.refresh() }}></div>
                        </div>
                    </div>
                    <div className="body-queue-head">
                        <div>预约日期</div>
                        <div>
                            <div style={{ fontSize: "0.33rem", color: "#111111" }}>{materialData?.vdef26}</div>
                        </div>
                    </div>
                    <div className="body-queue-head">
                        <div>预约时间段</div>
                        <div>
                            <div style={{ fontSize: "0.33rem", color: "#111111" }}>{materialData?.vdef27}</div>
                        </div>
                    </div>
                    <div className="body-queue-container">
                        <div className="container-body-head">
                            <div className="body-head-left">
                                <div>排队区名称</div>
                                <div>
                                    {materialData?.queueMonitor?.queuearea_name}
                                    {pk_org === "0001A1100000000030MV" ? (materialData?.queueMonitor?.vdef12 === "Y" ? '(一号线)' : (materialData?.queueMonitor?.vdef13 === 'Y' ? '(二号线)' : '')) : '' }
                                </div>
                            </div>
                            <div className="body-head-right">
                                <div>
                                    <div>还需等待</div>
                                    <div>
                                        <span className="count-color">{materialData?.queueMonitor?.waitNo}</span>
                                        <span>位</span>
                                    </div>
                                </div>
                                <div>
                                    <div>排队状态</div>
                                    <div style={{ fontSize: "0.35rem", fontWeight: "600",color:'red' }}>{materialData?.queueMonitor?.queueStatus.code === 4 ? '稍后叫号请等待' : materialData?.queueMonitor?.queueStatus?.name}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Space justify='center' block>
                        <Button
                            onClick={async () => {
                                let self = this;
                                const conf = await Dialog.confirm({
                                    content: '是否取消签到?',
                                });
                                if (conf) {
                                    let paramData = {
                                        action: "3",
                                        appid: "",
                                        param: {
                                            pk_stockorg: pk_org,
                                            pk_org: pk_org,
                                            pk_delivery: noticePK,
                                            cancelSign: true // 取消签到
                                        }
                                    }
                                    let result = changeStatus(paramData);
                                    result.then(res => {
                                        if (res) {
                                            if (res.statuscode === '0') {
                                                if (res.datas.queuemsg) {
                                                    Dialog.confirm({
                                                        content: res.datas.queuemsg,
                                                        onConfirm: function () {
                                                            let ignorequeueparam = {
                                                                action: "3",
                                                                appid: "",
                                                                param: {
                                                                    pk_stockorg: pk_org,
                                                                    pk_org: pk_org,
                                                                    pk_delivery: noticePK,
                                                                    cancelSign: true, // 取消签到
                                                                    ignorequeue: true // 忽略排队提醒
                                                                }
                                                            }
                                                            let result = changeStatus(ignorequeueparam);
                                                            result.then(res => {
                                                                if (res) {
                                                                    if (res.statuscode === '0') {
                                                                        self.refresh();
                                                                    } else {
                                                                        Toast.fail("取消失败：" + res.errinfo, 5);
                                                                    }
                                                                }
                                                            });
                                                        }
                                                    });
                                                } else {
                                                    self.refresh();
                                                }
                                            } else {
                                                Toast.fail("取消失败：" + res.errinfo, 5);
                                            }
                                        }
                                    });
                                }
                            }}
                            shape='rounded'
                            color='danger'>
                            取消签到
                        </Button>
                    </Space>
                </div>
                {/* <Code noticePK={ noticePK }></Code> */}
                <div style={{ height: '0.4rem' }}></div>
            </div>
        )
    }
}
